module.exports = __webpack_public_path__ + "static/img/yingrenTitle.b777891.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yingrenTitle.png
// module id = r4cR
// module chunks = 0